import { AxiosResponse } from 'axios';
import { SET_PROJECT_TRANSACTIONS, SET_PROJECT_TRANSACTION, SET_PROJECT_TRANSACTION_STATS, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PROJECT_TRANSACTION_ISLOADING,
  DELETE_PROJECT_TRANSACTION,
  EDIT_PROJECT_TRANSACTION,
  GET_PROJECT_TRANSACTIONS,
  GET_PROJECT_TRANSACTION,
  GET_PROJECT_TRANSACTION_STATS,
  REGISTER_PROJECT_TRANSACTION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ProjectTransaction from '@/services/project_transaction';
import { Module } from 'vuex';
import { EditProjectTransaction, RegisterProjectTransaction, GetProjectTransaction } from '@/dtos/project_transaction.dto';

const projectTransaction: Module<any, {}> = {
  state: {
    projectTransaction: {
      data: null,
      isLoading: false,
    },
    projectTransactions: {
      data: null,
      isLoading: false,
    },
    projectTransactionStats: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    projectTransaction: (state: { projectTransaction: any }) => state.projectTransaction,
    projectTransactions: (state: { projectTransactions: any }) => state.projectTransactions,
    projectTransactionStats: (state: { projectTransactionStats: any }) => state.projectTransactionStats,
  },
  mutations: {
    [SET_PROJECT_TRANSACTION]: (
      state: { projectTransaction: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectTransaction.data = payload.data) : null,
        (state.projectTransaction.isLoading = payload.isLoading);
    },
    [SET_PROJECT_TRANSACTIONS]: (
      state: { projectTransactions: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectTransactions.data = payload.data) : null,
        (state.projectTransactions.isLoading = payload.isLoading);
    },
    [SET_PROJECT_TRANSACTION_STATS]: (
      state: { projectTransactionStats: StateObject },
      payload: { data: null; isLoading: any }
    ) => {
      payload.data != null ? (state.projectTransactionStats.data = payload.data) : null,
        (state.projectTransactionStats.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PROJECT_TRANSACTION]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.registerProjectTransaction(
        payload as RegisterProjectTransaction
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT_TRANSACTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTION, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_TRANSACTIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_TRANSACTIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.getProjectTransactions(
        payload as GetProjectTransaction
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_TRANSACTIONS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_TRANSACTIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTIONS, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_TRANSACTION]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.getProjectTransactions(
        payload as GetProjectTransaction
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_TRANSACTION, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTION, { isLoading: false });
        return false;
      }
    },
    [EDIT_PROJECT_TRANSACTION]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.editProjectTransaction(
        payload as EditProjectTransaction
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_TRANSACTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTION, { isLoading: false });
        return false;
      }
    },
    [DELETE_PROJECT_TRANSACTION]: async ({ commit }: any, payload: string) => {
      commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.deleteProjectTransaction(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_TRANSACTION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_TRANSACTION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTION, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_TRANSACTION_STATS]: async ({ commit }: any, payload: { organizationId: string; projectId?: string }) => {
      commit(SET_PROJECT_TRANSACTION_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectTransaction.getProjectTransactionStats(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT_TRANSACTION_STATS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PROJECT_TRANSACTION_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_TRANSACTION_STATS, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PROJECT_TRANSACTION_ISLOADING]: ({ commit }) => {
      commit(SET_PROJECT_TRANSACTION, { isLoading: false });
      commit(SET_PROJECT_TRANSACTIONS, { isLoading: false });
    },
  },
};

export default projectTransaction;

